import api from '@/api/api'

const state = {
  listData: [],
  listTotal: 0,
  listHeader: [],
}

const mutations = {
  CLEAR_CHARTS: state => {
    state.listData = []
  },

  GET_CHARTS: (state, response) => {
    state.listData = Object.values(response.data)
    state.listTotal = response.headers['x-total-count']
  },

  GET_CHARTS_HEADER: (state, data) => {
    state.listHeader = data
  },
}

const actions = {
  getCharts: ({ commit, rootState }, params) => {
    return new Promise((resolve, reject) => {
      commit('CLEAR_CHARTS')
      api
        .getCharts({ ...params, userId: rootState.user.id })
        .then(response => {
          commit('GET_CHARTS', response)
          resolve(response)
        })
        .catch(error => {
          reject(error)
          console.log(error)
        })
    })
  },

  getChartsHeader: ({ commit }) => {
    return new Promise((resolve, reject) => {
      api
        .getTemplatesHeader()
        .then(response => {
          commit('GET_CHARTS_HEADER', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
          console.log(error)
        })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
